<i18n locale="en">
  {
    "labels": {
      "video": "Video"
    }
  }
  </i18n>

<template>
  <OwnInputContainer :label="t('labels.video')" :errors="video.status.errors">
    <YoutubeInput v-model="video.value" />
  </OwnInputContainer>
</template>

<script>
import { useI18n } from 'vue-i18n'

import YoutubeInput from '@/components/inputs/YoutubeInput'
import { WebsiteSectionValidators } from '@/features/website-builder/builder/validation/websiteSectionValidators'
import { FormBuilderModelSync } from '@/forms'
import { OwnInputContainer } from '@/ui/OwnInputContainer'

export default {
  name: 'ContentVideoEditor',
  components: {
    OwnInputContainer,
    YoutubeInput,
  },
  mixins: [
    FormBuilderModelSync({
      video: {
        debounce: 250,
        validateOnInit: true,
        validators: [WebsiteSectionValidators.required],
      },
    }),
  ],
  emits: ['update'],
  setup() {
    const { t } = useI18n()

    return { t }
  },
  methods: {
    onFormControlUpdate(controlName, value, status) {
      this.$emit('update', { controlName, status, value })
    },
  },
}
</script>
